export { FileManagerPaneComponent } from './file-manager-pane.component';
export { FileManagerPaneModule } from './file-manager-pane.module'
